import { render, staticRenderFns } from "./ManageLimitRate.vue?vue&type=template&id=0adbe60c&scoped=true"
import script from "./ManageLimitRate.vue?vue&type=script&lang=js"
export * from "./ManageLimitRate.vue?vue&type=script&lang=js"
import style0 from "./ManageLimitRate.vue?vue&type=style&index=0&id=0adbe60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adbe60c",
  null
  
)

export default component.exports